import React, { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  de: {
    nav: { home: "Start", safety: "Safety", course: "Kurs", feed: "Feed", about: "Über mich" },
    common: {
      readMore: "Mehr erfahren",
      brand: "Circle of Ikarus",
      tagline: "Das Safety-System für Reiter – gebaut von einer Kapitänin.",
      langLabel: "DE",
    },
    hero: {
      kicker: "Aviation trifft Reitsport",
      title: "Sicherheit ist kein Zufall.\nSie ist ein System.",
      sub: "Cockpit-Sicherheitskultur, übertragen auf den Sattel. Wissenschaftlich fundiert, systematisch, für sicherheitsbewusste Amateur-Reiter.",
      ctaSafety: "Pre-Ride Check starten",
      ctaStory: "Meine Geschichte",
      badge: "Basierend auf HFACS-Eq & Eq-Safety Model",
    },
    home: {
      pillarsTitle: "Warum ein System?",
      pillarsSub: "In der Luftfahrt verlassen wir uns nicht auf ein gutes Gefühl. Wir verlassen uns auf Checklisten, klare Standards und Human-Factors-Wissen. Genau das bringt Circle of Ikarus in den Reitsport.",
      pillars: [
        { t: "Checklisten statt Bauchgefühl", d: "Der Pre-Ride Check nach Piloten-Vorbild – Pferd, Ausrüstung, Umfeld und deine eigene Verfassung, systematisch geprüft." },
        { t: "Human Factors zählen", d: "Der Reiter-Selfcheck (IMSAFE, adaptiert) macht sichtbar, was oft übersehen wird: deine mentale und körperliche Verfassung." },
        { t: "Wissenschaft, nicht Meinung", d: "Verankert in HFACS-Eq und dem Eq-Safety Model von Dr. Meredith Chapman – peer-reviewed, mit Quellen und DOI." },
      ],
      horsesTitle: "Der Circle",
      horsesSub: "Fünf Persönlichkeiten. Ein gemeinsamer Nenner: Respekt und Sicherheit.",
      trackTitle: "Du trackst dein Training?",
      trackSub: "Circle of Ikarus ist eigenständig. Wenn du dein Training dokumentierst, wirf einen Blick auf TrackMyHorse.",
      trackCta: "Zu TrackMyHorse",
      sponsorsTitle: "Partner & Sponsoren",
      sponsorsSub: "Platz für Marken, die Sicherheit im Reitsport ernst nehmen.",
      sponsorSlot: "Dein Logo hier",
      sponsorCta: "Sponsor werden",
      advisoryTitle: "Wissenschaftlicher Beirat",
      advisorySub: "Wir bauen einen Beirat aus Expert:innen für Sicherheit, Human Factors und Pferdewissenschaft auf.",
      advisorySlot: "Position offen",
      newsletterTitle: "Bleib im Circle",
      newsletterSub: "Safety-Impulse, neue Standards und Geschichten aus Cockpit und Stall – direkt in dein Postfach.",
      newsletterPlaceholder: "deine@email.de",
      newsletterCta: "Anmelden",
      newsletterOk: "Danke! Du bist im Circle.",
    },
    safety: {
      title: "Safety-Modul",
      sub: "Dein Cockpit für sicheres Reiten. Systematisch prüfen, ehrlich bewerten, bewusst aufsteigen.",
      tabs: { preride: "Pre-Ride Check", selfcheck: "Selfcheck", standards: "Standard-Guide", fitness: "Athletik", context: "Stall & Transport", para: "Para-Safety", log: "Vorfall-Log" },
      para: {
        intro: "Sicherheit für Para-Reiter:innen – systematisch gedacht. Adaptierte Checks, Helfer-Rollen und Notfall-Kommunikation, orientiert an FEI Para Dressage Rules 2026 und RDA-Regelwerk.",
        gradesTitle: "Klassifizierung (Grad I–V)",
        gradesNote: "Vereinfachte Übersicht. Maßgeblich sind die offiziellen FEI-Klassifizierungsregeln.",
        equipmentTitle: "Adaptive Ausrüstung (kompensierende Hilfsmittel)",
        equipmentNote: "Im Turnier nur genehmigte Hilfsmittel laut Classification Master List – sonst Ausschluss.",
        sidewalkerTitle: "Helfer-Briefing: Sidewalker & Leader",
        emergencyTitle: "Notfall- & Kommunikationsprotokoll",
        prerideTitle: "Zusätzliche Pre-Ride-Punkte (Para)",
        awarenessTitle: "Awareness & Schulung der Reiter:innen",
      },
      fitness: {
        intro: "Sicherheit entsteht auch abseits des Sattels: durch die Athletik von Reiter UND Pferd. Wissenschaftlich fundierte Trainingsansätze, um Stürze seltener und Folgen milder zu machen.",
        riderTitle: "Reiter-Athletik",
        horseTitle: "Pferde-Athletik",
      },
      context: {
        intro: "Die meisten Reiter denken bei Sicherheit ans Reiten – dabei passieren viele Verletzungen am Boden, im Stall und beim Transport. Hier die wichtigsten Maßnahmen und typischen Fallstricke.",
        tips: "Sicher handeln",
        pitfalls: "Fallstricke",
        pitfallsTitle: "Typische Fallstricke auf einen Blick",
      },
      preride: {
        intro: "Vier Bereiche. Jeder Punkt bewusst abhaken. Erst wenn alles grün ist, bist du „READY“.",
        progress: "Fortschritt",
        ready: "READY",
        notReady: "NOCH NICHT READY",
        readyMsg: "Alle Checks bestanden. Bewusster, sicherer Ritt – viel Freude.",
        reset: "Zurücksetzen",
        remaining: "offen",
      },
      selfcheck: {
        intro: "IMSAFE – der Human-Factors-Check der Luftfahrt, adaptiert für Reiter. Sei ehrlich zu dir selbst. Jedes „Ja“ bei einem Risiko ist ein Signal, nicht ein Urteil.",
        allClear: "Grünes Licht – deine Verfassung spricht für einen Ritt.",
        caution: "Achtung: Mindestens ein Faktor ist erhöht. Überdenke Intensität, Pferdewahl oder den Ritt an sich.",
        yes: "Ja",
        no: "Nein",
      },
      standards: {
        intro: "Sicherheitsausrüstung ist nur so gut wie ihre Norm. Diese Übersicht orientiert sich an FEI-akzeptierten Standards (gültig ab 1. Januar 2026).",
        replaceTitle: "Helm nach Aufprall ersetzen",
        replaceMsg: "Ein Helm ist für genau einen Aufprall gebaut. Nach jedem Sturz mit Kopfkontakt – auch ohne sichtbaren Schaden – gehört der Helm ersetzt. FEI empfiehlt zudem, Helme alle 3–5 Jahre zu tauschen.",
        col: { item: "Ausrüstung", standard: "Akzeptierte Norm", note: "Hinweis" },
      },
      log: {
        intro: "Dein privates Logbuch für Beinah-Unfälle und Vorfälle. Was dokumentiert wird, kann analysiert werden – die Basis jeder Sicherheitskultur.",
        privacy: "Lokal & privat: Einträge sind nur mit diesem Gerät verknüpft (anonyme ID). Kein Login, keine Namen.",
        add: "Eintrag hinzufügen",
        empty: "Noch keine Einträge. Das ist gut – dokumentiere trotzdem jeden Beinah-Unfall.",
        stats: "Deine Auswertung",
        form: {
          date: "Datum",
          category: "Bereich (Triade)",
          phase: "Phase",
          severity: "Schweregrad",
          location: "Ort",
          horse: "Pferd (optional)",
          factors: "Begünstigende Faktoren",
          notes: "Notiz",
          save: "Eintrag speichern",
          cancel: "Abbrechen",
        },
      },
      sourcesTitle: "Wissenschaftliche Grundlage & Quellen",
      disclaimerTitle: "Haftungsausschluss",
    },
    feed: {
      title: "Feed & Social",
      sub: "Einblicke aus Cockpit und Stall. Folge dem Circle of Ikarus.",
      follow: "Folgen",
      soon: "Bald mehr",
    },
    about: {
      kicker: "Über mich",
      title: "Von der Flugbahn in die Reitbahn",
      body: [
        "Ich bin Kapitänin – und Reiterin. Zwei Welten, die enger verbunden sind, als es scheint. Im Cockpit habe ich gelernt, dass Sicherheit niemals Zufall ist. Sie ist das Ergebnis von Systemen, Checklisten und einer ehrlichen Einschätzung der eigenen Verfassung.",
        "Im Reitsport verlassen wir uns dagegen oft auf Routine und Bauchgefühl. Dabei arbeiten wir mit einem Lebewesen mit eigenem Willen und 500 Kilogramm Kraft. Genau hier entstand die Idee: Was, wenn wir die bewährte Sicherheitskultur der Luftfahrt in den Sattel bringen?",
        "Circle of Ikarus ist mein Versuch, genau das zu tun – nicht als Lifestyle, sondern als konkretes, wissenschaftlich fundiertes Werkzeug für sicherheitsbewusste Reiter.",
      ],
      contactTitle: "Kontakt",
      contactSub: "Presse, Kooperationen oder einfach Hallo sagen.",
      form: { name: "Name", email: "E-Mail", topic: "Anliegen", message: "Nachricht", send: "Senden", ok: "Danke! Deine Nachricht ist angekommen." },
      topics: { allgemein: "Allgemein", presse: "Presse", kooperation: "Kooperation", sponsoring: "Sponsoring" },
    },
    footer: {
      rights: "Alle Rechte vorbehalten.",
      disclaimer: "Circle of Ikarus schafft Bewusstsein und ein System für mehr Sicherheit. Es ersetzt keine professionelle, medizinische oder rechtliche Beratung und ist keine Sicherheitsgarantie.",
    },
  },
  en: {
    nav: { home: "Home", safety: "Safety", course: "Course", feed: "Feed", about: "About" },
    common: {
      readMore: "Learn more",
      brand: "Circle of Ikarus",
      tagline: "The safety system for equestrians – built by a captain.",
      langLabel: "EN",
    },
    hero: {
      kicker: "Aviation meets Equestrian",
      title: "Safety is not luck.\nIt is a system.",
      sub: "Cockpit safety culture, translated to the saddle. Scientifically grounded, systematic – for safety-minded amateur riders.",
      ctaSafety: "Start Pre-Ride Check",
      ctaStory: "My story",
      badge: "Based on HFACS-Eq & the Eq-Safety Model",
    },
    home: {
      pillarsTitle: "Why a system?",
      pillarsSub: "In aviation we don't rely on a good feeling. We rely on checklists, clear standards and human-factors knowledge. That is exactly what Circle of Ikarus brings to equestrian sport.",
      pillars: [
        { t: "Checklists over gut feeling", d: "The pilot-inspired Pre-Ride Check – horse, equipment, environment and your own condition, checked systematically." },
        { t: "Human factors matter", d: "The rider self-check (IMSAFE, adapted) surfaces what is often overlooked: your mental and physical state." },
        { t: "Science, not opinion", d: "Anchored in HFACS-Eq and the Eq-Safety Model by Dr. Meredith Chapman – peer-reviewed, with sources and DOI." },
      ],
      horsesTitle: "The Circle",
      horsesSub: "Five personalities. One common denominator: respect and safety.",
      trackTitle: "Tracking your training?",
      trackSub: "Circle of Ikarus stands on its own. If you document your training, take a look at TrackMyHorse.",
      trackCta: "Go to TrackMyHorse",
      sponsorsTitle: "Partners & Sponsors",
      sponsorsSub: "Space for brands that take safety in equestrian sport seriously.",
      sponsorSlot: "Your logo here",
      sponsorCta: "Become a sponsor",
      advisoryTitle: "Scientific Advisory Board",
      advisorySub: "We are building an advisory board of experts in safety, human factors and equine science.",
      advisorySlot: "Position open",
      newsletterTitle: "Stay in the Circle",
      newsletterSub: "Safety impulses, new standards and stories from cockpit and stable – straight to your inbox.",
      newsletterPlaceholder: "your@email.com",
      newsletterCta: "Subscribe",
      newsletterOk: "Thank you! You're in the Circle.",
    },
    safety: {
      title: "Safety Module",
      sub: "Your cockpit for safe riding. Check systematically, assess honestly, mount consciously.",
      tabs: { preride: "Pre-Ride Check", selfcheck: "Self-Check", standards: "Standards Guide", fitness: "Athleticism", context: "Stable & Transport", para: "Para-Safety", log: "Incident Log" },
      para: {
        intro: "Safety for para-equestrians – thought through systematically. Adapted checks, helper roles and emergency communication, based on FEI Para Dressage Rules 2026 and the RDA rulebook.",
        gradesTitle: "Classification (Grades I–V)",
        gradesNote: "Simplified overview. The official FEI classification rules are authoritative.",
        equipmentTitle: "Adaptive equipment (compensating aids)",
        equipmentNote: "In competition only approved aids per the Classification Master List – otherwise elimination.",
        sidewalkerTitle: "Helper briefing: sidewalkers & leaders",
        emergencyTitle: "Emergency & communication protocol",
        prerideTitle: "Additional pre-ride points (para)",
        awarenessTitle: "Awareness & rider education",
      },
      fitness: {
        intro: "Safety is also built away from the saddle: through the athleticism of rider AND horse. Science-based training approaches to make falls rarer and their consequences milder.",
        riderTitle: "Rider athleticism",
        horseTitle: "Horse athleticism",
      },
      context: {
        intro: "Most riders think of riding when it comes to safety – yet many injuries happen on the ground, in the stable and during transport. Here are the key measures and typical pitfalls.",
        tips: "Act safely",
        pitfalls: "Pitfalls",
        pitfallsTitle: "Typical pitfalls at a glance",
      },
      preride: {
        intro: "Four areas. Tick every point consciously. Only when everything is green are you \u201cREADY\u201d.",
        progress: "Progress",
        ready: "READY",
        notReady: "NOT READY YET",
        readyMsg: "All checks passed. Conscious, safe ride – enjoy it.",
        reset: "Reset",
        remaining: "open",
      },
      selfcheck: {
        intro: "IMSAFE – aviation's human-factors check, adapted for riders. Be honest with yourself. Every \u201cyes\u201d to a risk is a signal, not a verdict.",
        allClear: "Green light – your condition supports a ride.",
        caution: "Caution: at least one factor is elevated. Reconsider intensity, choice of horse, or the ride itself.",
        yes: "Yes",
        no: "No",
      },
      standards: {
        intro: "Safety equipment is only as good as its standard. This overview follows FEI-accepted standards (effective 1 January 2026).",
        replaceTitle: "Replace your helmet after impact",
        replaceMsg: "A helmet is built for exactly one impact. After any fall involving head contact – even without visible damage – replace it. FEI also recommends replacing helmets every 3–5 years.",
        col: { item: "Equipment", standard: "Accepted standard", note: "Note" },
      },
      log: {
        intro: "Your private logbook for near-misses and incidents. What gets documented can be analysed – the foundation of any safety culture.",
        privacy: "Local & private: entries are tied only to this device (anonymous ID). No login, no names.",
        add: "Add entry",
        empty: "No entries yet. That's good – still, document every near-miss.",
        stats: "Your breakdown",
        form: {
          date: "Date",
          category: "Area (triad)",
          phase: "Phase",
          severity: "Severity",
          location: "Location",
          horse: "Horse (optional)",
          factors: "Contributing factors",
          notes: "Note",
          save: "Save entry",
          cancel: "Cancel",
        },
      },
      sourcesTitle: "Scientific foundation & sources",
      disclaimerTitle: "Disclaimer",
    },
    feed: {
      title: "Feed & Social",
      sub: "Insights from cockpit and stable. Follow Circle of Ikarus.",
      follow: "Follow",
      soon: "More soon",
    },
    about: {
      kicker: "About me",
      title: "From flight path to riding arena",
      body: [
        "I am a commercial airline captain – and a rider. Two worlds more closely connected than they seem. In the cockpit I learned that safety is never luck. It is the result of systems, checklists and an honest assessment of one's own condition.",
        "In equestrian sport, however, we often rely on routine and gut feeling – while working with a living being that has its own will and 500 kilograms of power. That is exactly where the idea was born: what if we brought aviation's proven safety culture into the saddle?",
        "Circle of Ikarus is my attempt to do exactly that – not as a lifestyle, but as a concrete, scientifically grounded tool for safety-minded riders.",
      ],
      anon: "",
      contactTitle: "Contact",
      contactSub: "Press, cooperations or simply say hello.",
      form: { name: "Name", email: "Email", topic: "Topic", message: "Message", send: "Send", ok: "Thank you! Your message has arrived." },
      topics: { allgemein: "General", presse: "Press", kooperation: "Cooperation", sponsoring: "Sponsoring" },
    },
    footer: {
      rights: "All rights reserved.",
      disclaimer: "Circle of Ikarus creates awareness and a system for greater safety. It does not replace professional, medical or legal advice and is not a safety guarantee.",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("coi_lang") || "de");
  useEffect(() => {
    localStorage.setItem("coi_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const toggle = () => setLang((l) => (l === "de" ? "en" : "de"));
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
